var _path, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSeven(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 142,
    viewBox: "0 0 143 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.738 70.9999C140.738 109.435 109.593 140.58 71.1581 140.58C32.7235 140.58 1.57812 109.435 1.57812 70.9999C1.57812 32.5653 32.7235 1.41992 71.1581 1.41992C109.593 1.41992 140.738 32.5653 140.738 70.9999Z",
    fill: "url(#paint0_linear_1545_9263)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1545_9263)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 71.3153,
    cy: 70.9999,
    r: 61.3872,
    stroke: "#98A2B3",
    strokeWidth: 4.07895
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1545_9263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.3286 109.011C70.2457 109.011 69.1289 108.977 68.0459 108.875C59.619 108.131 51.7336 104.645 45.5403 98.9254C44.4573 97.9101 44.4235 96.218 45.5064 95.2027C46.4879 94.2889 48.0108 94.2889 48.9923 95.2027C54.3395 100.144 61.1758 103.19 68.4858 103.833C78.2665 104.679 87.9117 101.091 94.748 94.1874C95.6956 93.2398 97.1847 93.1721 98.2 94.0182C99.3168 94.9658 99.3845 96.658 98.3692 97.7071C91.2622 104.916 81.4815 109.011 71.3286 109.011Z",
    fill: "#98A2B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.034 102.953L42.9325 95.2706C42.8986 93.9507 43.9139 92.8339 45.2338 92.6985L52.95 91.9878C54.3376 91.8525 55.5897 92.9016 55.6913 94.2892C55.8266 95.6767 54.7775 96.9289 53.3899 97.0304L50.3779 97.3012C49.058 97.4366 48.0428 98.5534 48.0766 99.8733L48.1104 102.851C48.1443 104.239 47.0275 105.39 45.6061 105.424C44.2185 105.491 43.0678 104.374 43.034 102.953Z",
    fill: "#98A2B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4899 48.0259C43.373 47.0783 43.2715 45.3862 44.3206 44.337C52.2399 36.3162 63.4081 32.1874 74.6778 33.1688C83.1047 33.9134 90.9901 37.3992 97.1834 43.1187C98.2664 44.134 98.3002 45.8261 97.2172 46.8414C96.2358 47.7552 94.7128 47.7552 93.7314 46.8414C88.3842 41.9003 81.5479 38.8545 74.2378 38.2114C64.4572 37.3654 54.812 40.9527 47.9757 47.8567C46.9942 48.8043 45.5051 48.872 44.4899 48.0259Z",
    fill: "#98A2B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0313 47.7215C86.8959 46.334 87.9451 45.0818 89.3326 44.9802L92.3446 44.7095C93.6645 44.5741 94.6798 43.4573 94.646 42.1374L94.6121 39.1592C94.5783 37.7717 95.6951 36.621 97.1165 36.5872C98.5041 36.5533 99.6547 37.6702 99.6886 39.0916L99.7901 46.7739C99.8239 48.0938 98.8087 49.2106 97.4888 49.346L89.7726 50.0228C88.385 50.1582 87.1328 49.1091 87.0313 47.7215Z",
    fill: "#98A2B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.627 79.3646C53.627 80.6168 52.6117 81.5982 51.3934 81.5982H40.4959C39.1422 81.5982 38.0254 80.4814 38.0254 79.1277C38.0254 78.4508 38.2961 77.774 38.8038 77.334L45.5047 71.0731C47.0953 69.584 47.3322 68.6702 47.3322 67.858C47.3322 66.572 46.4861 65.7936 44.7601 65.7936C43.8125 65.7936 42.9326 66.0643 42.1881 66.6058C41.4097 67.1811 40.3944 67.2827 39.5822 66.8427C38.0592 65.9966 37.9239 63.8645 39.3791 62.8831C40.902 61.8001 42.8988 61.1909 45.3016 61.1909C49.9043 61.1909 53.0855 63.5599 53.0855 67.2827C53.0855 69.2117 52.544 71.0054 49.6674 73.6451L45.877 77.131H51.3595C52.6117 77.131 53.627 78.1124 53.627 79.3646Z",
    fill: "#98A2B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3421 77.7741H71.5975V78.8571C71.5975 80.38 70.3792 81.6322 68.8224 81.6322C67.2995 81.6322 66.0473 80.4139 66.0473 78.8571V77.7741H58.2634C56.7066 77.7741 55.4883 76.5219 55.4883 74.999C55.4883 74.4237 55.6575 73.8483 55.9959 73.3745L63.7121 62.6125C64.1521 61.9694 64.8966 61.5972 65.675 61.5972C67.6379 61.5972 68.7547 63.797 67.6718 65.3876L62.1554 73.273H66.2165V72.5285C66.2165 71.0394 67.401 69.8549 68.8901 69.8549C70.3792 69.8549 71.5637 71.0394 71.5637 72.5285V73.273H72.3082C73.5604 73.273 74.5419 74.2883 74.5419 75.5066C74.5757 76.7927 73.5604 77.7741 72.3421 77.7741Z",
    fill: "#98A2B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9461 57.5356C87.5029 57.5356 88.6197 59.0924 88.1121 60.5815L80.2605 82.9517C79.9559 83.8655 79.076 84.4747 78.0946 84.4747C76.5378 84.4747 75.421 82.9179 75.9286 81.4288L83.7802 59.0586C84.1186 58.1448 84.9647 57.5356 85.9461 57.5356Z",
    fill: "#98A2B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.713 64.5415C105.713 64.9476 105.646 65.3199 105.476 65.6922L99.3846 79.9062C98.9447 80.9554 97.9294 81.6322 96.7787 81.6322C94.7482 81.6322 93.3606 79.5339 94.1728 77.6726L99.2154 66.0983H93.9698V66.7751C93.9698 68.095 92.8868 69.178 91.5669 69.178C90.247 69.178 89.1641 68.095 89.1641 66.7751V64.0339C89.1641 62.714 90.247 61.631 91.5669 61.631H102.803C104.393 61.5972 105.713 62.917 105.713 64.5415Z",
    fill: "#98A2B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1545_9263",
    x: 7.88867,
    y: 7.57324,
    width: 126.854,
    height: 128.485,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.63158
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.815789
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1545_9263"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1545_9263",
    x: 38.0254,
    y: 33.0264,
    width: 67.6875,
    height: 77.616,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.63158
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.815789
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1545_9263"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1545_9263",
    x1: 22.8781,
    y1: 16.5666,
    x2: 124.408,
    y2: 115.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71136,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAC1CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSeven);
export default __webpack_public_path__ + "static/media/IconSeven.b48baf39f48f6c12d1e8b6bdd4730142.svg";
export { ForwardRef as ReactComponent };